module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-demi-f73dfb1d.eot";